<template>

    <div id="configuration">
        <div class="container-fluid">
            <UserMenu :showLogout="true"></UserMenu>
        </div>

        <div class="container" style="margin-top:50px">
            <div class="card">
                <div class="card-header">
                    <div class="navbar">
                        <ul class="nav nav-tabs card-header-tabs">
                            <li class="nav-item">
                                <a class="nav-link" :class="{active : tabindex == 0}" v-on:click="tabindex=0"><translate item="Config.Server.Tabname" /></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{active : tabindex == 1}" v-on:click="tabindex=1"><translate item="Config.Units.Tabname" /></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{active : tabindex == 2}" v-on:click="tabindex=2"><translate item="Config.Logs.Tabname" /></a>
                            </li>
                        </ul>

                        <div class="nav-item form-inline my-2 my-lg-0">
                            <div class="btn btn-success" v-on:click="saveConfig"><translate item="General.Save" /></div>
                            <span v-on:click="backtotimeline" class="btn btn-success"><translate item="Config.Start" /></span>
                        </div>
                    </div>
                </div>

                <div v-if="saveMessage.length" class="alert alert-success" role="alert">
                    {{saveMessage}}
                </div>

                <div class="card-body" v-if="tabindex==0">
                    <ul>
                        <li><translate item="Config.Server.ClientConfiguration" /> ({{version}})</li>
                        <li><translate item="Config.Server.ServerConfiguration" /> ({{serverVersion}})</li>
                    </ul>

                    <p class="card-text"><translate item="Config.Server.ValidateSettings" /></p>

                    <div class="form-group row">
                        <label class="col-sm-2" for="endpoint"><translate item="Config.Server.ServerUrl" /></label>

                        <div class="col-sm-4">
                            <input type="url" v-model="webRoot" class="form-control" id="endpoint" aria-describedby="endpoint" placeholder="">
                            <small id="emailHelp" class="form-text text-muted"><translate item="Config.Server.ServerUrl.Help" /></small>
                        </div>
                        <label class="col-sm-1" for="endpoint" v-on:click="check"><span v-if="!checking"><translate item="Config.Server.ServerUrl.Check" /></span><span v-else><translate item="Config.Server.ServerUrl.Busy" /></span></label>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-2" for="endpoint"><translate item="Config.Server.Terminal" /></label>

                        <div class="col-sm-4">
                            <input type="text" v-model="clientName" class="form-control" id="endpoint" aria-describedby="endpoint" placeholder="">
                            <small class="form-text text-muted"><translate item="Config.Server.Terminal.Help" /></small>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <h5><translate item="Config.Server.Status" /></h5>
                        </div>
                    </div>

                    <div class="status row">
                        <div class="col">
                            <div class="alert" :class="{'alert-primary': checking, 'alert-success' : isAlive, 'alert-danger': !isAlive}">
                                <translate item="Config.Server.Status.Online" /> : <span v-if="isAlive"><translate item="General.Yes" /></span><span v-else><translate item="General.No" /></span>
                            </div>
                        </div>

                        <div class="col">
                            <div class="alert" :class="{'alert-primary': checking, 'alert-success' : isAuthenticated, 'alert-danger': !isAuthenticated}">
                                <translate item="Config.Server.Status.Authorized" /> : <span v-if="isAuthenticated"><translate item="General.Yes" /></span><span v-else><translate item="General.No" /></span>
                            </div>
                        </div>

                        <div class="m-2 col-2" v-if="(!isAuthenticated && isAlive)">
                            <div class="alert alert-success">
                                <a href="/#login"><translate item="UserMenu.Login" /></a>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <h5><translate item="Config.Language" /></h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <select id="culture-select" v-model="selectedCulture" @change="cultureChanged">
                                <option v-for="culture in cultureOptions" :key="culture" :value="culture">
                                    {{ culture }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="card-body" v-if="tabindex==1">
                    <h5 class="card-title"><translate item="Config.Units.Title" /></h5>

                    <span class="card-text"><translate item="Config.Units.Content" /></span>

                    <div class="section text-left">
                        <div class="row">
                            <div class="col-4">
                                <div class="m-2 p-2 unitgroup">
                                    <div class="row pb-3">
                                        <div class="col-3"> <img class="unit-image" :src="webRoot + '/img/units/bonnen.png'" /></div>

                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="showCollect"><b><translate item="Config.Units.Packing" /></b></label>
                                        </div>
                                    </div>

                                    <p><translate item="Config.Units.Packing.WhatToShow" /></p>

                                    <hr />

                                    <p><translate item="Config.Units.Packing.SelectUnits" /></p>

                                    <div v-for="unitGroup in unitGroups" :key="unitGroup.id">
                                        <div class="row p-1">
                                            <div class="col-2">
                                                <img class="unit-image" :src="webRoot + '/img/units/' + unitGroup.imageUrl" />
                                            </div>

                                            <div class="col-10">
                                                <div class="form-check">
                                                    <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="unitGroup.collectSelected"><b>{{unitGroup.name}}</b></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <p><translate item="Config.Units.Packing.BonChefHelp" /></p>

                                    <div class="row pb-3">
                                        <div class="col-3"> <img class="unit-image" :src="webRoot + '/img/units/bonnen.png'" /></div>

                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="showBonChef"><b><translate item="Config.Units.Packing.BonChefCheck" /></b></label>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-4">
                                <div class="m-2 p-2 unitgroup">
                                    <div class="row pb-3">
                                        <div class="col-3"> <img class="unit-image" :src="webRoot + '/img/units/bonnen.png'" /></div>

                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="showServe"><b><translate item="Config.Units.Issuance" /></b></label>
                                        </div>
                                    </div>

                                    <p><translate item="Config.Units.Issuance.WhatToShow" /></p>

                                    <hr />

                                    <p><translate item="Config.Units.Issuance.SelectUnits" /></p>
                                    <div v-for="unitGroup in unitGroups" :key="unitGroup.id">
                                        <div class="row p-1">
                                            <div class="col-2">
                                                <img class="unit-image" :src="webRoot + '/img/units/' + unitGroup.imageUrl" />
                                            </div>

                                            <div class="col-10">
                                                <div class="form-check">
                                                    <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="unitGroup.serveSelected"><b>{{unitGroup.name}}</b></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="m-2 p-2 unitgroup">
                                    <div class="row pb-3">
                                        <div class="col-3"> <img class="unit-image" :src="webRoot + '/img/units/orders.png'" /></div>

                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="showOrders"><b><translate item="Config.Units.Orders" /></b></label>
                                        </div>
                                    </div>

                                    <p><translate item="Config.Units.Orders.WhatToShow" /></p>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="m-2 p-2 unitgroup">
                                    <div class="row pb-3">
                                        <div class="col-3"> <img class="unit-image" :src="webRoot + '/img/units/bonnen.png'" /></div>

                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="showReciepts"><b><translate item="Config.Units.Receipts" /></b></label>
                                        </div>
                                    </div>

                                    <p><translate item="Config.Units.Receipts.WhatToShow" /></p>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div class="row">
                            <div :class="getAccentClass(unitGroup)" v-for="unitGroup in unitGroups" :key="unitGroup.id">
                                <div class="m-2 p-2 unitgroup">
                                    <div class="row">
                                        <div class="col-3"><img class="unit-image" :src="webRoot + '/img/units/' + unitGroup.imageUrl" /></div>
                                        <div class="col-9 form-check">
                                            <label class="form-check-label"><input type="checkbox" class="form-check-input" v-model="unitGroup.selected"><b>{{unitGroup.name}}</b></label>
                                        </div>
                                    </div>

                                    <div class="row pt-4"><b class="col">{{unitGroup.units.length}} <translate item="Config.Units.UnitGroup" /></b></div>
                                    <!--<div class="row" :key="basket.id" v-for="basket in unitGroup.units">{{basket.nr}}</div>-->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card-body" v-if="tabindex==2">
                    <h5 class="card-title"><translate item="Config.Logs.Title" /></h5>

                    <div>
                        <div class="row" v-for="log in logs">
                            <div class="col-2">{{log.Date}}</div><div class="col-10">{{log.Message}}</div>
                        </div>
                        <hr />
                        <div class="btn btn-danger" v-on:click="deletelogs"><translate item="Config.Logs.DeleteLogs" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import 'bootstrap/scss/bootstrap.scss';
    import configRepository from '../repositories/ConfigRepository';
    import UserMenu from '../components/UserMenu.vue';
    import axios from 'axios';
    import logRepository from '../repositories/LogRepository';
    import translate from '../components/translate'
    import translationService from '../repositories/TranslateService';

    export default {

        name: 'configuration',

        data: function () {
            return {
                user: {},
                unitGroups: [],
                showOrders: true,
                showReciepts: true,
                showCollect: true,
                showServe: false,
                showBonChef: true,
                isRegistered: false,
                saveMessage: "",
                webRoot: configRepository.endPointUrl,
                version: configRepository.version,
                logs: logRepository.getLogs(),
                clientName: configRepository.clientName,
                checking: false,
                isAlive: false,
                isAuthenticated: false,
                tabindex: 0,
                configRepository: configRepository,
                selectedCulture: "nl-NL",
                cultureOptions: ["nl-NL", "en-US", "de-DE"]
            }
        },

        components: { UserMenu, translate },

        methods: {
            /*
            registerTerminal: function () {
                configRepository.registerTerminal(this.name).then(a => {
                    var config = getConfig();
                    config.authenticationHeader = a.authenticationHeader;
                    this.isRegistered = true;
                    saveConfig(config);
                });
            },
            */
            saveConfig: function () {

                var config = configRepository.getConfig();
                var reload = false;

                if (this.unitGroups.length) {
                    config.unitGroupIds = [];
                    config.collectUnitGroupIds = [];
                    config.serveUnitGroupIds = [];

                    for (var unit in this.unitGroups) {
                        // the unit groups to show
                        if (this.unitGroups[unit].selected) {
                            config.unitGroupIds.push(this.unitGroups[unit].id);
                        }
                        // the orders of this unit groups to show in the collect view
                        if (this.unitGroups[unit].collectSelected) {
                            config.collectUnitGroupIds.push(this.unitGroups[unit].id);
                        }
                        // the orders of this unit groups to show in the collect view
                        if (this.unitGroups[unit].serveSelected) {
                            config.serveUnitGroupIds.push(this.unitGroups[unit].id);
                        }

                    }
                }

                if (config.endPointUrl != this.webRoot) {
                    // make sure the trailing slash is present.
                    this.webRoot = this.webRoot.replace(new RegExp("/$"), "") + "/";
                    config.endPointUrl = this.webRoot;
                    reload = true;
                }

                config.showOrders = !!this.showOrders;
                config.showReciepts = !!this.showReciepts;
                config.showCollect = !!this.showCollect;
                config.clientName = this.clientName;
                config.showServe = !!this.showServe;
                config.showBonChef = !!this.showBonChef;
                config.selectedCulture = this.selectedCulture;

                configRepository.saveConfig(config);

                if (reload) {
                    window.document.location = '/#config';
                }

                this.saveMessage = "The configuration is successfully saved";
                var clientName = config.clientName;

                if (!clientName) {
                    clientName == 'unknown';
                }

                logRepository.sendLogsToServer(clientName).then(function () { });
            },

            getAccentClass: function (unit) {
                var className = {};
                className['accent' + unit.accentColor] = 1;
                className['col-4'] = 1;
                return className;
            },

            check: function () {
                var _this = this;
                _this.checkIsAlive(function () { _this.checkIsAuthenticated() });
            },

            checkIsAlive: function (callback) {
                var _this = this;
                _this.checking = true;

                axios({
                    method: 'GET',
                    url: _this.webRoot + 'api/terminal/isAlive',
                    withCredentials: true
                }).then(function (response) {
                    _this.checking = false;
                    if (response.data) {
                        _this.isAlive = true;
                        callback && callback();
                    } else {
                        _this.isAlive = false;
                        _this.isAuthenticated = false;
                    }
                }).catch(function () {
                    _this.checking = false;
                    _this.isAlive = false;
                    _this.isAuthenticated = false;
                });
            },

            checkIsAuthenticated: function (successCallback) {
                var _this = this;
                _this.checking = true;

                axios({
                    method: 'GET',
                    url: _this.webRoot + 'api/terminal/isAuthenticated',
                    withCredentials: true
                }).then(function (response) {
                    _this.checking = false;
                    if (response.data.success) {
                        _this.isAuthenticated = true;

                        configRepository.user.name = response.data.username;

                        successCallback && successCallback();
                    } else {
                        _this.isAuthenticated = false;
                    }
                }).catch(function () {
                    _this.checking = false;
                    _this.isAuthenticated = false;
                    _this.isAlive = false;
                });
            },

            backtotimeline: function () {
                window.location = "/";
            },

            deletelogs: function () {
                logRepository.clearLogs();
                this.logs = [];
            },

            cultureChanged() {
                var config = configRepository.getConfig();
                config.selectedCulture = this.selectedCulture;

                configRepository.saveConfig(config);

                translationService.ReloadDictionary();
            }
        },

        computed: {
            serverVersion: function () {
                return configRepository.serverVersion;
            }
        },

        mounted: function () {

            var _this = this;

            var config = configRepository.getConfig();
            this.user = configRepository.user;

            this.checkIsAlive();

            this.checkIsAuthenticated(function () {
                configRepository.getAllUnits().then(a => {
                    _this.unitGroups = a;
                    for (var unitGroup in a) {
                        if (config.unitGroupIds.indexOf(a[unitGroup].id) >= 0) {
                            _this.unitGroups[unitGroup].selected = true;
                        }

                        if (config.collectUnitGroupIds.indexOf(a[unitGroup].id) >= 0) {
                            _this.unitGroups[unitGroup].collectSelected = true;
                        }

                        if (config.serveUnitGroupIds.indexOf(a[unitGroup].id) >= 0) {
                            _this.unitGroups[unitGroup].serveSelected = true;
                        }
                    }
                }).catch(a => { window.console.log("* Config.vue error: " + a); });
            });

            if (config.hasOwnProperty("selectedCulture")) {
                _this.selectedCulture = config.selectedCulture;
            }
            else {
                // If config does not contain the selected language, set to browser language

                _this.selectedCulture = (() => {
                    var lang = navigator.language || navigator.userLanguage;

                    if (lang.includes("nl")) return "nl-NL";
                    else if (lang.includes("de")) return "de-DE";
                    else return "en-US";
                })();

                this.cultureChanged();
            }
            config.selectedCulture = _this.selectedCulture;

            this.showOrders = config.showOrders;
            this.showReciepts = config.showReciepts;
            this.showCollect = config.showCollect;
            this.showServe = config.showServe;
            this.showBonChef = config.showBonChef;
            this.selectedCulture = config.selectedCulture;

            if (window.location.hash.toLowerCase() == "#configreconnect") {
                // connection is lost in normal planning view, poll the connection and return to the planning
                window.setInterval(function () {
                    _this.checkIsAlive(function () {
                        _this.checkIsAuthenticated(function () {
                            if (_this.isAuthenticated) {
                                window.location = "/";
                            }
                        });
                    });
                }, 10000);
            }
        }
    };
</script>

<style scoped>
    .unitgroup {
        background-color: #FFF;
        min-height: 150px;
        border-radius: 10px;
        border: 1px #808080 solid;
    }

    .form-check-input {
        height: 18px;
        width: 18px;
    }

    .card-header, .navbar {
        padding-bottom: 1px;
    }
</style>
